/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement } from 'react';

import { OverridableComponent } from '@mui/material/OverridableComponent';

import { SvgIconTypeMap } from '@mui/material';

import { useTheme } from '@mui/material/styles';

import useMediaQuery from '@mui/material/useMediaQuery';

import IconButton from '../../../../../components/IconButton';

import { openLinkOnEvent } from '../../../utils/openLinkOnEvent';

interface AlternativeEnvironmentButtonBaseProps {
  title: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> | string;
  url: string;
  badgeContent?: string | number;
}

export default function AlternativeEnvironmentButtonBase({
  title,
  icon,
  url,
  badgeContent,
}: AlternativeEnvironmentButtonBaseProps): ReactElement {
  const theme = useTheme();
  const isLargerThanOrEqualToSmallScreen = useMediaQuery(
    theme.breakpoints.up('sm')
  );

  return (
    <IconButton
      badgeContent={badgeContent}
      title={title}
      icon={icon}
      onClick={(e) => openLinkOnEvent(e, url)}
      onMouseDown={(e) => e.stopPropagation()}
      onFocus={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      sx={{
        color: 'white',
        svg: {
          height: isLargerThanOrEqualToSmallScreen ? '2em' : '1.25em',
          width: isLargerThanOrEqualToSmallScreen ? '2em' : '1.25em',
        },
        path: {
          color: 'white',
          stroke: 'white',
        },
      }}
    />
  );
}
